var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



// WEBPACK FOOTER //
// webpack://pdfjs-dist/build/pdf/node_modules/core-js/modules/_has.js